import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonUse", "data-selenium-test", "options", "resolver", "specialOptions", "error", "onChange", "onBlur"];
/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { List } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import PropertyOptionRecord from 'customer-data-objects/property/PropertyOptionRecord';
import { Component } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ReferenceResolverType from 'reference-resolvers/schema/ReferenceResolverType';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import TeamSelect from 'ui-addon-teams/components/TeamSelect';
import isEmpty from 'transmute/isEmpty';
import FilterOperatorErrorType from 'customer-data-filters-ui/components/propTypes/FilterOperatorErrorType';
import { atomToPromise } from 'customer-data-filters-ui/utils/atomToPromise';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
const getOptions = (options, specialOptions, resolver) => {
  if (resolver) {
    return List.isList(specialOptions) ? specialOptions : List();
  }
  if (List.isList(options) && List.isList(specialOptions)) {
    return specialOptions.concat(options);
  }
  if (isEmpty(options) && List.isList(specialOptions)) {
    return specialOptions;
  }
  return options || List();
};
export default class FilterOperatorTeamInput extends Component {
  constructor(props) {
    super(props);
    this.onOpenChange = evt => {
      this.setState({
        isOpen: evt.target.value
      });
      if (evt.target.value === false && this.props.onBlur) {
        this.props.onBlur();
      }
    };
    this.onChange = evt => {
      this.props.onChange(evt, this.state.isOpen);
    };
    this.loadTeams = this.loadTeams.bind(this);
    this.state = {
      isLoading: true,
      teams: List(),
      isOpen: false
    };
  }
  componentDidMount() {
    const {
      resolver
    } = this.props;
    this.loadTeams(resolver);
  }
  loadTeams(resolver) {
    if (resolver && typeof resolver.all !== 'function') {
      Raven.captureException(new Error(`[Expected a reference resolver] resolver for Team Input does not have 'all' function`));
    }
    if (!resolver || !resolver.all) {
      return;
    }
    const promise = atomToPromise(resolver.all());
    promise.then(resp => {
      this.setState({
        isLoading: false,
        teams: resp.toList()
      });
    });
  }
  render() {
    const _this$props = this.props,
      {
        buttonUse,
        'data-selenium-test': dataSeleniumTest,
        options,
        resolver,
        specialOptions,
        error
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      isLoading,
      teams
    } = this.state;
    return /*#__PURE__*/_jsx("div", {
      "data-selenium-test": dataSeleniumTest,
      children: /*#__PURE__*/_jsx(TeamSelect, Object.assign({
        buttonUse: buttonUse,
        customOptions: getOptions(options, specialOptions, resolver),
        isLoading: isLoading,
        onChange: this.onChange,
        onOpenChange: this.onOpenChange,
        showPlaceholder: true,
        showTags: true,
        teams: teams,
        uiFormControlProps: {
          error: error.get('error'),
          validationMessage: error.get('error') ? error.get('message') : null
        }
      }, rest))
    });
  }
}
FilterOperatorTeamInput.propTypes = {
  buttonUse: PropTypes.string,
  'data-selenium-test': PropTypes.string,
  error: FilterOperatorErrorType.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  options: ImmutablePropTypes.listOf(PropTypes.instanceOf(PropertyOptionRecord)),
  resolver: ReferenceResolverType,
  specialOptions: ImmutablePropTypes.listOf(PropTypes.instanceOf(PropertyOptionRecord)),
  value: ImmutablePropTypes.listOf(PropTypes.string)
};
FilterOperatorTeamInput.defaultProps = {
  buttonUse: 'form'
};